// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import {
    getOpenPipSummary,
    getTransferApprovalCount,
    getWip
} from '../shared/repositories';
import actions from '../actions-list';
import {buildTransferPayload} from '../shared/services/home-page-helper';

export const readWip = isCloudPrefferred =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allWip = await getWip();

            if (isCloudPrefferred) {

                allWip.productTracking.transferApprovals = 0;

            }

            dispatch({
                data: allWip,
                type: actions.GET_WIP
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readOpenPipSummary = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allOpenPipSummary = await getOpenPipSummary();

            dispatch({
                data: allOpenPipSummary,
                type: actions.GET_OPEN_PIP_SUMMARY
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readTransferApprovalCount = selectedAccounts =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const transferPayload = buildTransferPayload(selectedAccounts, '', '');

        try {

            const transferApprovalCount = await getTransferApprovalCount(transferPayload);

            dispatch({
                data: transferApprovalCount.productTracking.transferApprovals,
                type: actions.GET_TRANSFER_APPROVAL_COUNT
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/wip.js